import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {EmisorService} from "../recursos/servicios/emisor.service";
import {UtilConfig} from "../../../../../autenticacion/servicios/UtilConfig";
import {Router} from "@angular/router";
import {MatSnackBar} from "@angular/material";
import * as moment from 'moment';
import {isNullOrUndefined} from "util";
import {Certificado} from "../recursos/modelo/certificado";

declare var swal: any;

declare const $: any;


interface FileReaderEventTarget extends EventTarget {
    result: string;
}

interface FileReaderEvent extends Event {
    target: FileReaderEventTarget;

    getMessage(): string;
}


@Component({
    selector: 'cmp-conf-pse',
    templateUrl: './view/cmp-conf-pse.component.html',
    styleUrls: ['./css/cmp-conf-pse.component.scss'],
    providers: [EmisorService]
})
export class CmpConfPseComponent implements OnInit, OnChanges {
    panelOpenState: boolean = false;
    loading: boolean = false;
    @Input() emisor;
    @Input() transformaciones;
    @Input() integrationTypes;
    diferenciasDias: number = 0;
    empresaAdmin = false;
    urlBack;

    constructor(private emisorService: EmisorService,
                private router: Router,
                private util: UtilConfig,
                public snackBar: MatSnackBar) {
        this.urlBack = this.util.URL_WS_BACKEND;

        let empresa = this.util.getCurrentUser().customer.id;
        if (empresa.toString() == this.util.ESCON_CUSTOMER.toString()) {
            this.empresaAdmin = true;
        }
    }

    openSnackBar(message: string, action: string) {
        this.snackBar.open(message, action, {
            duration: 2000,
        });
    }

    ngOnInit() {
        // Prepare the preview certificate
        this.transformaciones.forEach((item) => {
            if (item.value.id === this.emisor.parserType.id) {
                this.emisor.parserType = item.value;
            }
        });
    }

    verificarCertificado($event) {
        const input = $event.currentTarget;

        if (input.files && input.files[0]) {
            const reader = new FileReader();
            reader.onload = (e: FileReaderEvent) => {
                this.emisor.certificate = e.target.result.split("base64,")[1];
                if (this.emisor.certificateTO)
                    this.emisor.certificateTO = new Certificado();
                this.emisor.certificateTO.certificate = e.target.result.split("base64,")[1];
                this.emisor.rutaCertificado = $("#wizard-pse-certificado").val();
            };
            reader.readAsDataURL(input.files[0]);
        }
    }

    cargarCertificado() {
        // LLAMADO AL SERVICIO

        if (!isNullOrUndefined(this.emisor.certificatePassword) && this.emisor.certificatePassword != "" &&
            !isNullOrUndefined(this.emisor.certificateTO.certificate) && this.emisor.certificateTO.certificate != "") {
            this.loading = true;
            this.emisorService.verificarCertificado(this.emisor)
                .subscribe(result => {
                    this.loading = false;
                    if (result.codigo == 0) {
                        swal({
                            title: 'Error validando certificado',
                            text: result.mensaje,
                            type: 'error',
                            showCancelButton: false,
                            showConfirmButton: true,
                        });
                        return false
                    }
                    this.emisor.certificateTO = result.certificate;
                    var a = moment(this.emisor.certificateTO.fechFinal);
                    var b = moment();
                    this.diferenciasDias = a.diff(b, 'days');
                }, err => {
                    this.loading = false;
                    this.util.manejoError(err, this.router);
                });
        } else {
            swal({
                title: "Debe ingresar clave",
                width: 400,
                html: '<p style="padding-left: 17px !important;"><b>Debe cargar un certificado junto con su clave publica.</b></p>',
                type: 'error'
            });
        }
    }


    ngOnChanges(changes: SimpleChanges) {
        const input = $(this);

        if (input[0].files && input.files[0]) {
            const reader: any = new FileReader();

            reader.onload = (e: FileReaderEvent) => {
                this.emisor.certificate = e.target.result;
            };
            reader.readAsDataURL(input.files[0]);
        }
    }

}



// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/seguridad/emisor/cmp-conf-pse/cmp-conf-pse.component.ts